module.exports = "/img/downloadqr.d3398e31.png";